var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5635",
    "data-name": "Group 5635",
    transform: "translate(-827 -477)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_862",
    "data-name": "Ellipse 862",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(827 477)",
    fill: "#fce8e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5561",
    "data-name": "Group 5561",
    transform: "translate(840 490.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28824",
    "data-name": "Path 28824",
    d: "M19,20H5a2,2,0,0,1-2-2V9A2,2,0,0,1,5,7H19a2,2,0,0,1,2,2v9A2,2,0,0,1,19,20Z",
    fill: "none",
    stroke: "#db7267",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28825",
    "data-name": "Path 28825",
    d: "M16.5,14a.5.5,0,1,1,.5-.5A.5.5,0,0,1,16.5,14Z",
    fill: "none",
    stroke: "#db7267",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28826",
    "data-name": "Path 28826",
    d: "M18,7V5.6a2,2,0,0,0-2.515-1.932L4.485,6.6A2,2,0,0,0,3,8.537V9",
    fill: "none",
    stroke: "#db7267",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/paymentIcon.8044cd4b9053aa2dc8becdb3484a4940.svg";
export { ForwardRef as ReactComponent };